export default __webpack_public_path__ + "static/media/tab.72e3a0d7.png";